import React from 'react';

const Error = ({message}) => {
    return (
        <p className="text-red-500 text-sm extra-bold font-medium">{message}</p>
    );
};

export default Error;